import { createUseStyles } from 'react-jss';

import { ITheme, mediaQuery } from '../../../styles';
import { MENU_COLLAPSE_BREAKPOINT } from '../SingleToolNavigation';

const MAX_WIDTH = 1440;
const HEADER_OFFSET = 24;

const useStyles = createUseStyles<string, { noBorder: boolean }, ITheme>(
  ({ breakpoints }: ITheme) => ({
    root: {
      position: 'sticky',
      top: 0,
      backgroundColor: 'white',
      zIndex: 105,
      boxShadow: ({ noBorder }) => (noBorder ? 'none' : '0px 0.5px 0px var(--x-border-2)'),

      [mediaQuery(breakpoints.mobile)]: {
        padding: '0px 24px',
      },

      [mediaQuery(MENU_COLLAPSE_BREAKPOINT)]: {
        '& $logo': {
          order: 1,
          marginLeft: 18,
        },
        '& $search': {
          display: 'none',
        },
        '& $navContainer': {
          alignItems: 'center',
        },
      },
    },
    container: {
      padding: `0 ${HEADER_OFFSET}px`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      maxWidth: MAX_WIDTH,
      margin: 'auto',

      [mediaQuery(breakpoints.mobile)]: {
        padding: '0px',
      },
    },
    logo: {
      marginRight: 0,
    },
    navContainer: {
      display: 'flex',
      alignItems: 'center',
      // gap: 16,
    },
    buttonsContainer: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'flex-end',
      width: 76,
    },
    search: {
      position: 'absolute',
      right: 'calc(100% - 32px)',
      top: 0,
    },
    shareButton: {
      marginLeft: 0,
    },
  }),
  { name: 'single-tool-header' },
);

export default useStyles;
